<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'DonateAmountField',
  components: { FontAwesomeIcon },
  props: {
    modelValue: {
      type: [String,Number],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(7)
    },
    required: {
      type: Boolean,
      default: false
    },
    prepend: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  emits: ['update:modelValue', 'update'],
  computed: {
    textSize() {
      return [
        {'text-sm': !this.size},
        {'text-2xl': this.size === 'lg'},
        {'text-sm': this.size === 'sm'},
      ]
    },
    inputClasses() {
      return [
        'font-sans donate-amount-field block ring-0 focus:ring-0 focus:bg-white w-full font-semibold border-0 border-b-4 text-blue-600 focus:border-b-4 border-blue-500 placeholder:text-gray-400 bg-white text-center',
        '[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none',
        {'text-sm': !this.size},
        {'text-6xl': this.size === 'lg'},
        {'': this.size === 'sm'},
        // width of the input based on the length of the content,
        // this is a hack to make the input field width dynamic

      ]
    },
    fieldWidth() {
      if(this.modelValue && this.modelValue.length > 1) {
        return this.modelValue.length*3
      }
      else {
        return 7
      }
    },
    fieldStyle() {
      return {
        width: `${this.fieldWidth}rem`
      }
    }
  },
  mounted() {
    this.$refs.field.focus()
  }
}
</script>

<template>
  <div class="flex flex-row justify-center">
    <span :class="['text-blue-600', ...textSize, 'mt-5']"><font-awesome-icon icon="dollar-sign" /></span>
    <div class="">
      <input
        :id="id"
        ref="field"
        :style="fieldStyle"
        pattern="(?:0|[1-9]\d*)"
        inputMode="decimal" autoComplete="off" :required="required"
        :value="modelValue" type="number" :name="id"
        :class="inputClasses" :placeholder="placeholder"
        @input="$emit('update:modelValue', $event.target.value)"
      >
    </div>
  </div>
</template>

<style scoped>

</style>
